import React, { FC, useEffect, useRef, useState } from 'react'
import SessionConnector, { ConnectorProps as SessionProps } from 'containers/Session'
import AccountLinksDropDown from './AccountLinksDropDown'
import MobileConnector, { ConnectorProps as MobileConnectorProps } from 'connectors/Screen'
import styles from './Account.module.scss'
import classNames from 'classnames'
import { useHeaderContext } from '../../HeaderContext'

type AccountProps = SessionProps & MobileConnectorProps

const Account: FC<AccountProps> = (props) => {
  const { userInitials, isMobileScreenWidth } = props
  const { setMobileHeaderConfig } = useHeaderContext()
  const [dropdownIsOpen, handleDropdownOpen] = useState<boolean>(false)
  const [dropdownIsHovered, setDropdownIsHovered] = useState<boolean>(false)
  const accountRef = useRef<HTMLDivElement>(null)

  const handleClick = () => {
    handleDropdownOpen((prevState) => !prevState)
    setDropdownIsHovered(false)
    if (isMobileScreenWidth) {
      setMobileHeaderConfig((previousMobileHeaderConfig) => ({
        ...previousMobileHeaderConfig,
        mobileMenuContent: 'user',
        mobileTopHeader: 'user',
        isMobileMenuOpen: true,
      }))
    }
  }

  const handleDropdownHovered = (booleanFlag) => {
    return () => {
      if (!isMobileScreenWidth) {
        setDropdownIsHovered(booleanFlag)
      }
    }
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (accountRef.current && !accountRef.current.contains(event.target)) {
        handleDropdownOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div
      className={styles.accountDropDownMenu}
      onMouseOver={handleDropdownHovered(true)}
      onMouseLeave={handleDropdownHovered(false)}
      onFocus={handleDropdownHovered(true)}
      onBlur={handleDropdownHovered(false)}
      data-type='account-icon'
      ref={accountRef}
    >
      <button
        type='button'
        aria-label='authentication links'
        className={classNames(styles.accountIcon, {
          [styles.accountIconMobile]: isMobileScreenWidth,
        })}
        onClick={handleClick}
        data-type={`account-initials${isMobileScreenWidth ? '-mobile' : ''}`}
      >
        <span className={styles.accountIconInitials}>{userInitials}</span>
      </button>
      <AccountLinksDropDown dropdownIsOpen={dropdownIsOpen} dropdownIsHovered={dropdownIsHovered} />
    </div>
  )
}

export default SessionConnector(MobileConnector(Account))
